import React, { useState } from "react";
import { RoutePathNames } from "../helpers/Constants";
import { Typography, Toolbar, AppBar, IconButton, Menu, MenuItem, Divider, ListItemIcon, } from "@mui/material";
import { AccountCircle, Logout, Menu as MenuIcon, Home } from "@mui/icons-material";
import '../App.css'
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/store";
import { callServerTepngUserLogout } from "../helpers/Utils";

interface AppBarHeaderProps {
    onToggleDrawer: () => void
    header: string
    drawerHidden: boolean
    appBarHeight: number
}

export function AppBarHeader({ header, appBarHeight, drawerHidden, onToggleDrawer }: AppBarHeaderProps) {
    const navigate = useNavigate()
    const userLoggedOn = useAppSelector(state => state.loggedOnUserProfile.value);
    const appBar: React.CSSProperties = {
        height: appBarHeight,
        zIndex: 1300,
        top: 0,
        backgroundColor: "#FFFFFF",
        border: 1,
        borderColor: "#000000"
    }


    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState<Element | null>(null);


    const logout = async () => {
        setShowProfileMenu(false)
        await callServerTepngUserLogout()
    }

    const displayUserProfile = () => {
        setShowProfileMenu(false)
    }

    return (
        <AppBar style={appBar}>
            <Toolbar classes={{ regular: "ToolbarRegular" }}>
                {drawerHidden !== true &&
                    <>
                        <IconButton color="default" onClick={() => onToggleDrawer()} edge="start" > <MenuIcon /></IconButton>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        
                    </>
                }
                <img style={{ height: '30px' }} src='logo.png' alt="logo.png" />
                <div style={{ flexGrow: 1 }} />
                <Typography variant="h6" color="textDisabled" fontWeight="bold" > {header}   </Typography>
                <div style={{ flexGrow: 1 }} />
<IconButton size="large" color="secondary" onClick={() => navigate("/" + RoutePathNames.HOMEPAGE)} edge="start" > <Home fontSize="large" /></IconButton>&nbsp;&nbsp;

                <Typography variant="subtitle2" color="textPrimary"> {userLoggedOn == null ? 'No User logged in' : `Welcome ${userLoggedOn.Email}`}</Typography>
                {userLoggedOn &&
                    <>
                        <IconButton color="info" edge="end" title={userLoggedOn.Email} onClick={(event) => { setProfileMenuAnchorEl(event.currentTarget); setShowProfileMenu(previous => !previous) }}> <AccountCircle fontSize="large" /></IconButton>
                        <Menu style={{ zIndex: 1400 }} anchorEl={profileMenuAnchorEl} open={showProfileMenu} onClose={() => { setShowProfileMenu(false) }}>
                            <MenuItem onClick={displayUserProfile}><ListItemIcon><AccountCircle /></ListItemIcon>Profile</MenuItem>
                            <Divider />
                            <MenuItem onClick={() => logout()}><ListItemIcon><Logout /></ListItemIcon>Logout</MenuItem>
                        </Menu>
                    </>
                }
            </Toolbar>
        </AppBar>
    )
}
